<form data-testid="cost-form" [formGroup]="form" novalidate>
  <div class="grid grid-nogutter">
    <div class="col-12 py-2">
      <p>{{ 'shared.modal.component.add_cost.basic_information' | translate }}</p>
    </div>
    <div class="col-12 py-2 lg:px-5 p-fluid">
      <div class="p-field p-float-label p-input-icon-left">
        <i class="pi pi-wallet"></i>
        <input id="name" pInputText type="text" formControlName="name">
        <label for="name">{{ 'shared.modal.component.add_cost.name' | translate }}</label>
      </div>
    </div>
    <div class="col-12 py-2 lg:px-5 p-fluid">
      <div class="p-field p-float-label p-input-icon-left">
        <p-inputNumber
          id="priceNet"
          formControlName="priceNet"
          mode="currency"
          currency="USD"
          locale="en-US"
          [minFractionDigits]="2"
        ></p-inputNumber>
        <label for="priceNet">{{ 'shared.modal.component.add_cost.price' | translate }}</label>
      </div>
    </div>
    <div class="col-12 py-2 lg:px-5 p-fluid">
      <div class="p-field p-float-label p-input-icon-left">
        <p-calendar
          formControlName="incurredAt"
          appendTo="body"
          inputId="incurredAt"
          [readonlyInput]="true"
          [showIcon]="true"
          [touchUI]="true"
        ></p-calendar>
        <label for="incurredAt">{{ 'shared.modal.component.add_cost.incurred_at' | translate }}</label>
      </div>
    </div>
    <div class="col-12 py-2 lg:px-5 p-fluid">
      <div class="p-field p-float-label">
        <p-dropdown
          id="linkType"
          [options]="linkTypeOptions"
          optionLabel="label"
          optionValue="value"
          formControlName="linkType"
        ></p-dropdown>
        <label for="linkType">{{ 'shared.modal.component.add_cost.link_type.label' | translate }}</label>
      </div>
    </div>
    <div *ngIf="isGoalLink" class="col-12 py-2 lg:px-5 p-fluid">
      <div class="p-field p-float-label">
        <p-dropdown
          id="goal"
          [options]="goalOptions"
          optionLabel="label"
          optionValue="value"
          formControlName="goal"
        ></p-dropdown>
        <label for="goal">{{ 'shared.modal.component.add_cost.goal' | translate }}</label>
      </div>
    </div>
    <div *ngIf="isTaskLink" class="col-12 py-2 lg:px-5 p-fluid">
      <div class="p-field p-float-label">
        <p-dropdown
          id="task"
          [options]="taskOptions"
          optionLabel="label"
          optionValue="value"
          formControlName="task"
        ></p-dropdown>
        <label for="task">{{ 'shared.modal.component.add_cost.task' | translate }}</label>
      </div>
    </div>
  <div class="col-12 py-2 lg:px-5 p-fluid">
    <div class="p-field p-float-label p-input-icon-left">
      <i class="pi pi-pencil"></i>
      <textarea
        class="add-cost__description"
        id="description"
        [rows]="3"
        pInputTextarea
        [autoResize]="true"
        formControlName="description"
      ></textarea>
      <label for="description">{{ 'shared.modal.component.add_cost.description' | translate }}</label>
    </div>
  </div>
  </div>
</form>
